import {
  post,
  get,
  postJson,
  deleteApi,
  put,
  imagePost,
} from "./jhk/axios2.js";

/***
 * 计量单位列表查询
 * @param p
 */
export const measureUnitPage = (p) => postJson(`/measureUnit/page`, p);

/***
 * 新增、编辑计量单位接口
 * @param p
 */
export const measureUnitAdd = (p) => postJson(`/measureUnit/addOrEdit`, p);

/***
 * 启用停用计量单位接口
 * @param p
 */
export const measureUnitSet = (p) => postJson(`/measureUnit/setStatus`, p);

/***
 * 计量单位关联商品分页接口
 * @param p
 */
export const unitSkuPage = (p) => postJson(`/measureUnit/unitSkuPage`, p);

/***
 * 计量单位添加商品接口
 * @param p
 */
export const addUnitSku = (p) => postJson(`/measureUnit/addUnitSku`, p);

/***
 * 导入计量单位商品
 * @param p
 */
export const importUnitSku = (url, p) =>
  imagePost(`/measureUnit/importUnitSku${url}`, p);

/***
 * 计量单位删除关联商品接口
 * @param p
 */
export const delUnitSku = (id) => deleteApi(`/measureUnit/delUnitSku?id=${id}`, {});
